<template>
	<button-reasoning @click="buttonHandler" :active="reasoning" :changeColor="true" />
</template>

<script setup lang="ts">
import ButtonReasoning from '@/components/ui/ButtonReasoning.vue'
import { useComposerStore } from '@/stores/composer'
import { computed } from 'vue'

const emit = defineEmits<{
	toggleReasoningMode: []
}>()
const composerStore = useComposerStore()
const reasoning = computed(() => composerStore.reasoning)

function buttonHandler() {
	emit('toggleReasoningMode')
}
</script>
